/* 3O1 Watches interactions. No tracking, no timers that change stock or prices. */
(function () {
  if (window.__o1Loaded) return;
  window.__o1Loaded = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-o1-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function stickyBar() {
    var bar = document.querySelector('[data-o1-sticky]');
    if (!bar) return;
    var formId = bar.getAttribute('data-o1-sticky');
    var form = document.getElementById(formId);
    var button = form ? form.querySelector('[type="submit"]') : null;
    var trigger = bar.querySelector('[data-o1-sticky-buy]');
    if (!form || !button || !trigger) return;
    if (button.disabled) { trigger.setAttribute('disabled', 'disabled'); }
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (button.disabled) return;
      button.click();
    });
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', !entry.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(button);
  }

  function atcLabels() {
    var flags = document.querySelectorAll('[data-o1-atc-label], [data-o1-preorder-label]');
    Array.prototype.forEach.call(flags, function (flag) {
      var formId = flag.getAttribute('data-o1-form');
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return;
      var label = flag.getAttribute('data-o1-preorder-label') || flag.getAttribute('data-o1-atc-label');
      var button = form.querySelector('[type="submit"]');
      var span = button ? button.querySelector('span') : null;
      if (span && label && !button.disabled) span.textContent = label;
    });
  }

  function init(root) {
    reveal(root);
    if (!root) {
      stickyBar();
      atcLabels();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { reveal(event.target); });
})();
